/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungDto } from '../../models/buchung-dto';

export interface GetOneBuchung$Json$Params {

/**
 * ID der Buchung
 */
  buchungsId: string;

/**
 * Flag if soft-deleted Buchungen should be included in the result
 */
  includeDeleted?: boolean;
}

export function getOneBuchung$Json(http: HttpClient, rootUrl: string, params: GetOneBuchung$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<BuchungDto>> {
  const rb = new RequestBuilder(rootUrl, getOneBuchung$Json.PATH, 'get');
  if (params) {
    rb.path('buchungsId', params.buchungsId, {});
    rb.query('includeDeleted', params.includeDeleted, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuchungDto>;
    })
  );
}

getOneBuchung$Json.PATH = '/v1/buchungen/{buchungsId}';
